import React from "react";
import Stack from "@/components/atoms/Stack";
import Text from "@/components/atoms/Text";
import { Skeleton } from "@mantine/core";
import { Task } from "@/types";
import { useTranslation } from "react-i18next";

interface SellerTabProps {
  shippingAddress: string | undefined;
  task: Task;
  onClose: () => void;
}

const SellerTab: React.FC<SellerTabProps> = (props) => {
  const { shippingAddress, task } = props;

  const { t } = useTranslation();

  return (
    <>
      <Stack gap={16} p={16}>
        <Text size="lg" display="technical" tt="uppercase" strong={true}>
          {task.counterParty}
        </Text>
        <Text>
          {t("tasks:youHave")} {task.orderIds.length} {t("tasks:ordersToBeSent")}
        </Text>
        {shippingAddress === undefined ? (
          <Skeleton height={20} radius="md" width={"50%"} />
        ) : (
          <Text c={"dimmed"}>{shippingAddress}</Text>
        )}
      </Stack>
    </>
  );
};

export default SellerTab;
